





















import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Employee from '@/models/Employee';
import ContactInfo from '@/models/ContactInfo';
import User from '@/models/User';
import Skill, { Level } from '@/models/Skill';

@Component
export default class EmployeeSkills extends Vue {
  @Getter
  currentUser: User;
}
